import { BLACK_5, BLACK_a, MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const Wrapper = styled.div`
  margin-top: 6rem;
  display: flex;
  flex-direction: column;
  gap: 10rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    margin-top: 8rem;
  }
`;

export const BtnBox = styled.div`
  display: flex;
  justify-content: center;
  gap: 3rem;

  & > div {
    cursor: pointer;
    padding: 1rem 3rem;

    border-radius: 25rem;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
    font-size: 2.5rem;
    line-height: 5rem;

    &:nth-child(1) {
      background: ${(props) => (props.isActive ? "rgba(33, 246, 80, 0.1)" : "#010201")};
      border: 1px solid ${(props) => (props.isActive ? ` ${MAIN_GREEN}` : `${BLACK_5}`)};
      color: ${(props) => (props.isActive ? ` ${MAIN_GREEN}` : `${BLACK_a}`)};
    }
    &:nth-child(2) {
      background: ${(props) => (props.isActive ? "#010201" : "rgba(33, 246, 80, 0.1)")};
      border: 1px solid ${(props) => (props.isActive ? ` ${BLACK_5}` : `${MAIN_GREEN}`)};
      color: ${(props) => (props.isActive ? ` ${BLACK_a}` : `${MAIN_GREEN}`)};
    }
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    gap: 2rem;
    & > div {
      padding: ${(props) => (props.language === "en" ? "0.5rem 1.5rem" : "0.5rem 2rem")};
      font-size: ${(props) => (props.language === "en" ? "1.6rem" : "2rem")};
      line-height: ${(props) => (props.language === "en" ? "3.2rem" : "3.6rem")};
    }
  }
`;
